import type { SortOption } from "@/components/ui/sort-dropdown";

export const PERSONA_SORT_OPTIONS: readonly SortOption<"name" | "recent">[] = [
  { value: "name", label: "Name (A–Z)" },
  { value: "recent", label: "Recently added" },
];

export type PersonaSortKey = "name" | "recent";
export type PersonaStatusFilter = "all" | "active" | "archived";

export interface PersonaListItem {
  id: string;
  name: string;
  role: string;
  brief?: string | null;
  context?: string | null;
  status?: string | null;
  createdAt?: string | Date | null;
}
